import ApiConnectionsIcon from './ApiConnectionsIcon'
import ApiManagementServicesIcon from './ApiManagementServicesIcon'
import AppConfigurationIcon from './AppConfigurationIcon'
import AppServicePlansIcon from './AppServicePlansIcon'
import AzureCosmosDBIcon from './AzureCosmosDBIcon'
import AzureIoTIcon from './AzureIoTIcon'
import ConnectionsIcon from './ConnectionsIcon'
import DataFactoriesIcon from './DataFactoriesIcon'
import DataLakeStorageIcon from './DataLakeStorageIcon'
import FunctionAppsIcon from './FunctionAppsIcon'
import MachineLearningServiceWorkspacesIcon from './MachineLearningServiceWorkspacesIcon'
import MonitorIcon from './MonitorIcon'
import NotificationHubsIcon from './NotificationHubsIcon'
import SQLDBIcon from './SQLDBIcon'

const AzureIcons = {
    ApiConnectionsIcon,
    ApiManagementServicesIcon,
    AppConfigurationIcon,
    AppServicePlansIcon,
    AzureCosmosDBIcon,
    AzureIoTIcon,
    ConnectionsIcon,
    DataFactoriesIcon,
    DataLakeStorageIcon,
    FunctionAppsIcon,
    MachineLearningServiceWorkspacesIcon,
    MonitorIcon,
    NotificationHubsIcon,
    SQLDBIcon,
} 

export default AzureIcons